// extracted by mini-css-extract-plugin
export default {"linkLotsDataTable":"linkLotsDataTable-dyi16","table":"table-rAcHq"};